<template>
  <div id="ServiceDetail">
    <div class="banner container-fuild text-center">相关服务</div>
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-3" id="myScrollspy">
          <ServiceList
            :title="'特色服务'"
            :items="serviceNavList"
            :activeIndex="active"
            @tab-change="changeTab"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-9 content wow zoomIn">
          <div
            class="content-block"
            v-for="(item, index) in serviceContentList"
            :key="index"
          >
            <h2 :id="item.id">
              {{ item.title }}
              <small>/ {{ item.eng_title }}</small>
            </h2>
            <div v-html="item.content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { WOW } from "wowjs";
import ServiceList from "@/components/ServiceList.vue";
export default {
  name: "ServiceDetail",
  components: {
    ServiceList,
  },
  data() {
    return {
      id: "section-1",
      active: 0,
      serviceNavList: [
        {
          path: "/servicedetail",
          name: "高效的服务能力",
        },
        {
          path: "/servicedetail",
          name: "资深的行业专家",
        },
        {
          path: "/servicedetail",
          name: "先进的技术应用架构",
        },
        {
          path: "/servicedetail",
          name: "完备的交付能力体系",
        },
      ],
      serviceContentList: [
        {
          id: "section-1",
          title: "高效的服务能力",
          eng_title: "Efficient Service Capability",
          content:
            "<p>我们是深耕医疗行业的高新技术企业，提倡高效工作、服务为先的工作原则，为用户提供贴合业务场景的产品及服务。</p>",
        },
        {
          id: "section-2",
          title: "资深的行业专家",
          eng_title: "Professional Industry Experts",
          content:
            "<p>团队成员拥有多年大型省市级项目建设经验，熟悉医疗健康和公共卫生业务，可指导用户业务系统进行顶层设计，提供专家咨询服务。</p>",
        },
        {
          id: "section-3",
          title: "先进的技术应用架构",
          eng_title: "Advanced Technology Architecture",
          content:
            "<p>采用微服务架构体系，具备强大的数据中台和人工智能（知识图谱）产品能力，能为用户提供先进的架构保障体系和数据治理能力。</p>",
        },
        {
          id: "section-4",
          title: "完备的交付体系",
          eng_title: "Complete Delivery System",
          content:
            "<p>采用精益管理模式，以循环瀑布式的方法响应客户需求，结合完善的测试体系，保障项目的顺利交付。</p>",
        },
      ],
    };
  },
  mounted() {
    this.id = this.$route.params.id;
    var top = document.getElementById(this.id).offsetTop;
    $(window).scrollTop(top + 300);
    // $("#myNav").affix({
    //   offset: {
    //     top: 300,
    //   },
    // });
    var wow = new WOW();
    wow.init();
  },
  methods: {
    changeTab(i) {
      this.active = i;
    },
  },
};
</script>
<style scoped>
.banner {
  color: #fff;
  font-size: 30px;
  height: 150px;
  line-height: 150px;
  background-image: url("../assets/img/brand-hero.svg");
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: scroll;
  background-position: center center;
}
ul.nav-tabs {
  width: 200px;
  margin-top: 40px;
  border-radius: 4px;
  background: #fff;
  z-index: 99999;
  border: 1px solid #474747;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.067);
}
ul.nav-tabs li {
  text-align: center;
  margin: 0;
  border-top: 1px solid #474747;
}
ul.nav-tabs p {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  background: #474747;
  margin: 0;
  padding: 10px 0;
}
ul.nav-tabs li:first-child {
  border-top: none;
}
ul.nav-tabs li a {
  margin: 0;
  padding: 8px 16px;
  border-radius: 0;
}
ul.nav-tabs li.active a,
ul.nav-tabs li.active a:hover {
  color: #fff;
  background: #474747;
  border: 1px solid #474747;
}
ul.nav-tabs li:first-child a {
  border-radius: 4px 4px 0 0;
}
ul.nav-tabs li:last-child a {
  border-radius: 0 0 4px 4px;
}
ul.nav-tabs.affix {
  top: 30px;
}
.content-block {
  margin: 50px 0;
}
.content-block > h2 {
  padding: 20px 0;
  border-bottom: 1px solid #ccc;
}
</style>



// WEBPACK FOOTER //
// src/view/ServiceDetail.vue